/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */
import React, { type JSX } from 'react';
import styles from './FormLayout.module.css';
import { useTranslation } from '../Translation/translationProvider';

interface Props {
  header?: string;
  subHeader?: string;
  button?: React.ReactNode;
  backButton?: React.ReactNode;
  disabled?: boolean;
  submitButton?: React.ReactNode;
  backLink?: React.ReactNode;
  additionBottomElement?:JSX.Element
}

const FormLayout: React.FC<React.PropsWithChildren<Props>> = ({
  header,
  subHeader,
  children,
  backButton,
  disabled = false,
  submitButton,
  additionBottomElement,
  backLink
}) => {

  const {t} = useTranslation();


  const getSubmitButton = () => {
    if (submitButton) return <><div className={styles.submit}>{submitButton}</div>{additionBottomElement}</>;
    return (
      <div className={styles.bottom}>
        {/* <span className={styles.requiredLabel}>* Required field</span> */}
        <div>
          <button
            id="submit_button"
            className={styles.submitButton}
            type="submit"
            disabled={disabled}
          >
            {t("common.continueButton")}
          </button>
        </div>
        {additionBottomElement}
      </div>
    );
  };

  return (
    <main className={styles.main}>
      {backButton && <div>{backButton}</div>}
      <div className={styles.grid}>
        <div className={styles.formGroup}>
          <div className={styles.headerGroup}>
          
            {header && ( 
              <h1
                className={`${styles.header}`}
                dangerouslySetInnerHTML={{ __html: t(header) }}
              />
            )}
            {header && subHeader && (
              <div
                className={styles.subHeader}
                dangerouslySetInnerHTML={{ __html: t(subHeader) }}
              />
            )}
          </div>
          {children && <div className={styles.formElements}>{children}</div>}
        </div>
        {backLink && <div>{backLink}</div>}
        {getSubmitButton()}
      </div>
    </main>
  );
};

export default FormLayout;
